<i18n lang="yaml">
en:
  notification: 'All prices include 20% VAT'
ru:
  notification: 'Цена всех услуг указана с учетом НДС 20%'
</i18n>

<template>
  <p class="tax-notification">
    {{ $t('notification') }}
  </p>
</template>

<script>
export default {
  name: 'TaxNotification'
}
</script>

<style lang="scss">
.tax-notification {
  display: block;
  font-size: 12px;
  line-height: 16px;
}
</style>